// src/taskpane/services/types.ts

/** 支持的翻译目标语言 */
export interface TranslationLanguage {
  code: string;       // Azure Translator 语言代码，如 "zh-Hans", "en", "ja"
  name: string;       // 显示名称，如 "简体中文", "English", "日本語"
  nativeName: string; // 原生名称，如 "简体中文", "English", "日本語"
}

/** 从幻灯片中提取的文本项 */
export interface ExtractedTextItem {
  /** 唯一标识，用于翻译后回写定位 */
  id: string;
  /** 所属幻灯片索引 (0-based) */
  slideIndex: number;
  /** 形状在幻灯片 shapes 集合中的索引 (0-based)，用于精确回写定位 */
  shapeIndex: number;
  /** 形状名称（仅供参考，不用于定位，因为同名形状可能存在多个） */
  shapeName: string;
  /** 形状类型 */
  shapeType: "textbox" | "shape" | "placeholder" | "table" | "group-child";
  /** 对于表格：行索引 (0-based)，非表格时为 null */
  tableRowIndex: number | null;
  /** 对于表格：列索引 (0-based)，非表格时为 null */
  tableColIndex: number | null;
  /** 原始文本内容 */
  originalText: string;
  /** 翻译后的文本（初始为空） */
  translatedText: string;
  /** 是否翻译成功 */
  translated: boolean;
  /** 错误信息（如有） */
  error: string | null;
}

/** 文本提取结果 */
export interface ExtractionResult {
  items: ExtractedTextItem[];
  totalSlides: number;
  totalTextItems: number;
  totalCharacters: number;
}

/** 翻译进度回调 */
export type TranslationProgressCallback = (
  completed: number,
  total: number,
  currentItem: string
) => void;

/** 翻译结果 */
export interface TranslationResult {
  items: ExtractedTextItem[];
  successCount: number;
  failCount: number;
  skippedCount: number;
}

/** 插件设置（存储在 localStorage） */
export interface AddinSettings {
  apiKey: string;
  apiRegion: string; // Azure 区域，如 "eastasia", "global"
  defaultTargetLanguage: string;
}

/** 预设语言列表 */
export const SUPPORTED_LANGUAGES: TranslationLanguage[] = [
  { code: "zh-Hans", name: "简体中文", nativeName: "简体中文" },
  { code: "zh-Hant", name: "繁体中文", nativeName: "繁體中文" },
  { code: "en", name: "英语", nativeName: "English" },
  { code: "ja", name: "日语", nativeName: "日本語" },
  { code: "ko", name: "韩语", nativeName: "한국어" },
  { code: "fr", name: "法语", nativeName: "Français" },
  { code: "de", name: "德语", nativeName: "Deutsch" },
  { code: "es", name: "西班牙语", nativeName: "Español" },
  { code: "pt", name: "葡萄牙语", nativeName: "Português" },
  { code: "ru", name: "俄语", nativeName: "Русский" },
  { code: "ar", name: "阿拉伯语", nativeName: "العربية" },
  { code: "it", name: "意大利语", nativeName: "Italiano" },
  { code: "th", name: "泰语", nativeName: "ไทย" },
  { code: "vi", name: "越南语", nativeName: "Tiếng Việt" },
  { code: "id", name: "印尼语", nativeName: "Bahasa Indonesia" },
];

/** 自动检测语言选项 */
export const AUTO_DETECT_LANGUAGE: TranslationLanguage = {
  code: "auto",
  name: "自动检测",
  nativeName: "Auto Detect",
};
